export default __webpack_public_path__ + "static/media/NextProject6.60ef2163.png";